export default __webpack_public_path__ + "./images/tc.4473fabb.png";